import React, { useState, useEffect } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { toast } from "react-toastify";
import moment from "jalali-moment";

// import JS files
import TableIconModal from "../../../shares/TableIconModal";
import useFetch from "../../../../context/useFetch";
import MuiButton from "../../../shares/MuiButton";
import OrderCardLeftPartTemplate from "../../../shares/OrderCardLeftPartTemplate";
import SizeTextGrid from "../../../shares/SizeTextGrid";
import AdminOrderCard from "../../../admin-panels/shares/AdminOrderCard";
import { useSetting } from "../../../../context/SettingContext";
import { fixNumbers } from "../../../../utils";
// import { defaultRingSize } from "../../../../constants/constants";

const OrderDetails = (props) => {
  const { defaultRingSize } = useSetting();
  const [openModal, setOpenModal] = useState(false);

  const [currentOerdersDetail, setCurrentOerdersDetail] = useState({
    results: [],
    detail: {},
  });
  const [initialValues, setInitialValues] = useState({});
  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));
  const update_nums = (ringId, ind, nValue) => {
    let beforeNums = { ...initialValues };

    beforeNums[ringId][ind] = nValue;
    setInitialValues(beforeNums);
  };
  const [itemIsActive, setItemIsActive] = useState({});
  const getCreateOrderDetailsApi = useFetch({
    method: "get",
    url: `ProviderOrder_Service/${props.selectedRow?.id}/provider_get_order_item_detail_from_order`,
    trigger: false,
    setter: setCurrentOerdersDetail,
    argFunc: (res) => {
      let tmp = {};
      let tmp_active = {};

      res.results.map((item, ind) => {
        tmp[item.id] = [];
        tmp[item.id].push(item.admin_size_one_num);
        tmp[item.id].push(item.admin_size_two_num);
        tmp[item.id].push(item.admin_size_three_num);
        tmp[item.id].push(item.admin_size_four_num);
        tmp[item.id].push(item.admin_size_five_num);
        tmp[item.id].push(item.admin_size_six_num);

        tmp_active[item.id] = [];
        tmp_active[item.id] = item.is_active;
      });
      getOrderDetailsBangleApi.reFetch();

      setItemIsActive(tmp_active);
      setInitialValues(tmp);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const [selectedItem, setSelectedItem] = useState();
  const [patchData, setPatchData] = useState();
  const [childrenItemDate, setChildrenItemDate] = useState();
  const [selecteItemStatus, setSelectItemStatus] = useState();
  const [editable, setEditable] = useState(false);
  const [orderBangleStatus, setOrderBangleStatus] = useState({
    not_ready_list: [],
    ready_list: [],
    unchange_list: [],
  });
  const getOrderDetailsBangleApi = useFetch({
    method: "get",
    url: `ProviderOrder_Service/${props.selectedRow?.id}/admin_get_bangle_detail_for_provider_order`,
    trigger: false,
    // setter: setCurrentOerdersDetail,
    // params: { admin_change_item: statusFilter },
    argFunc: (res) => {
      setOrderBangleStatus({
        not_ready_list: res.not_ready_list,
        ready_list: res.ready_list,
        unchange_list: res.unchange_list,
      });

      let bangle_id = [];

      currentOerdersDetail.results.map((it, ind) => {
        if (res.ready_list.includes(it.id)) bangle_id.push(it.id);
      });

      // setBangleCheckBox(bangle_id);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const updateOrderApi = useFetch({
    method: "post",
    url: `ProviderOrder_Service/${props.selectedRow?.id}/provider_own_create_new_provider_order_factor`,
    trigger: false,
    data: { order_items: orderBangleStatus.ready_list },

    argFunc: (res) => {
      // toast.success("سفارش با موفقیت به سفارش های جاری منتقل شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      // props.setNewOerdersList({ results: [] });

      setOpenModal(false);
      getCreateOrderDetailsApi.reFetch();
      props.getRequestListApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const updateDetailsApi = useFetch({
    method: "patch",
    url: `ProviderOrderItem_Service/${selectedItem}`,
    trigger: false,
    data: patchData,

    argFunc: (res) => {
      // toast.success("ویرایش سفارش  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getCreateOrderDetailsApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const update_ring_item = (ringItemId) => {
    setSelectedItem(ringItemId);
    setPatchData({
      admin_size_one_num:
        initialValues[ringItemId][0] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][0]))
          : 0,
      admin_size_two_num:
        initialValues[ringItemId][1] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][1]))
          : 0,
      admin_size_three_num:
        initialValues[ringItemId][2] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][2]))
          : 0,
      admin_size_four_num:
        initialValues[ringItemId][3] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][3]))
          : 0,
      admin_size_five_num:
        initialValues[ringItemId][4] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][4]))
          : 0,
      admin_size_six_num:
        initialValues[ringItemId][5] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][5]))
          : 0,
      receive_at: moment(childrenItemDate).format("YYYY-MM-DD"),
      // is_active: true,
      admin_change_item: true,
    });

    // let before = { ...itemIsActive };
    // before[ringItemId] = true;
    // setItemIsActive(before);
    // setSelectItemStatus(true);
    setCurrentOerdersDetail({
      results: [],
      detail: {},
    });
    updateDetailsApi.reFetch();
  };

  const move_date_to_parent = (date) => {
    setChildrenItemDate(date);
  };

  const editable_component_data = (date, id) => {
    setEditable(date);
    let before = { ...itemIsActive };
    before[id] = !before[id];
    setItemIsActive(before);
  };

  const admin_change_order_to_on_onprogress = () => {
    updateOrderApi.reFetch();
  };

  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined)
        if (props.selectedRow.hasOwnProperty("id")) {
          getCreateOrderDetailsApi.reFetch();
        }
  }, [openModal]);
  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<RemoveRedEyeIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <div>
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <div className="">
                <span className="show-label">
                  کد سفارش:{" "}
                  <span className="show-value">
                    {" "}
                    {currentOerdersDetail.detail?.unique_id}
                  </span>
                </span>
              </div>
              <div className="mr-4">
                <span className="show-label">
                  تولیدکننده:{" "}
                  <span className="show-value">
                    {" "}
                    {currentOerdersDetail.detail?.name}
                  </span>
                </span>
              </div>
            </div>
            {/* <div className="md:block">
              <MuiButton
                onClick={admin_change_order_to_on_onprogress}
                variant="contained"
                // icon={<DoneIcon />}
                color="primary"
                text="تایید نهایی "
                disabled={updateOrderApi.loading}
              />
            </div> */}
          </div>
          <div className="border-b border-dashed my-2"></div>
          <SizeTextGrid haveExtraCol have5Col />
          <div className="overflow-scroll max-h-96">
            {currentOerdersDetail.results.map((item, index) => {
              return [
                <AdminOrderCard
                  update_ring_item={update_ring_item}
                  // edit_ring_item={edit_ring_item}
                  // showAcceptBtn
                  DontshowEditIconForAdmin
                  item={item}
                  move_date_to_parent={move_date_to_parent}
                  // editable_component={editable_component_data}
                  adminNeedDifference
                >
                  <OrderCardLeftPartTemplate
                    nums={nums}
                    update_nums={update_nums}
                    dynamicMap={true}
                    data_item={item}
                    // adminCantEdit
                    ringId={item.id}
                    adminCantEdit
                    adminDidntNeedCustomerRequestNum
                    adminNeedColor
                  />
                </AdminOrderCard>,
              ];
            })}
          </div>
        </div>
      </TableIconModal>
    </>
  );
};

export default OrderDetails;
